import { ContactModalVisible } from './reducers/contactus';
export const user = (state: { user: UserResp }) => {
  return state.user || {};
};

export const currentTeam = (state: any): TeamInfo => {
  try {
    return (
      state.team.find(({ uid }: any) => uid === state.user.lastTeamUid) || {}
    );
  } catch (err) {
    return {} as TeamInfo;
  }
};
export const allTeams = (state: any): TeamInfo[] => {
  return Array.isArray(state.team) ? state.team : [];
};
export const products = (state: { products: TeamProductResp[] }) =>
  state.products || [];

// export const allProjects = (state: any) => state.project.list || [];
// export const currentProject = (state: any) => {
//   try {
//     return (
//       state.project.list.find(
//         ({ uid }: any) => uid === state.project.current
//       ) ||
//       state.project.list[0] ||
//       {}
//     );
//   } catch (e) {
//     return {};
//   }
// };
export const currentResourceGroup = (state: any) => {
  try {
    return state.resourceGroup.current;
  } catch (e) {
    return undefined;
  }
};
export const resourceGroups = (state: any) => {
  try {
    return state.resourceGroup.resourceGroups;
  } catch (e) {
    return undefined;
  }
};

export const contactModalVisible = (state: any): ContactModalVisible => {
  return (
    state?.contactus ?? {
      visible: false,
    }
  );
};
export const rechargeModalVisible = (state: any): RechargeModalVisible => {
  return (
    state?.recharge ?? {
      visible: false,
    }
  );
};
export const belongSolana = (state: any): boolean => {
  const _currentTeam = currentTeam(state);
  return _currentTeam.partner === 'solana';
};
